import { render } from "./ProfileRules.vue?vue&type=template&id=d356d494&scoped=true"
import script from "./ProfileRules.vue?vue&type=script&lang=js"
export * from "./ProfileRules.vue?vue&type=script&lang=js"

import "./ProfileRules.vue?vue&type=style&index=0&id=d356d494&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d356d494"]])

export default __exports__